import { Routes } from '@angular/router';
import { permissionGuard } from 'src/lib/guards/permission.guard';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { FLIGHTS_CONFIG } from './base/flights-config';

/**
 * Flights Feature Routes
 *
 * Modern Angular 21+ 패턴:
 * - Standalone components with lazy loading
 * - Role guard integration (ADMIN_MASTER)
 * - Nested child routes (list → detail)
 *
 * URLs:
 * - List Page: /master/flights/list
 * - Detail/Edit Page: /master/flights/list/:id
 * - Redirect: /master/flights → /master/flights/list
 */
export const flightsRoutes: Routes = [
  {
    path: FLIGHTS_CONFIG.routePath, // 'master/flights' (Config-Driven)
    canActivate: [roleGuard('ADMIN_MASTER')],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/flights-list-page/flights-list-page.component'
          ).then((m) => m.FlightsListPageComponent),
        canActivate: [permissionGuard(...(FLIGHTS_CONFIG.permissions ?? []))],
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/flights-detail-page/flights-detail-page.component'
              ).then((m) => m.FlightsDetailPageComponent),
          },
        ],
      },
    ],
  },
];
